import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "src/environments/environment";
import { ApiEnum, HttpDataService } from "./http-data.service";

/** Debe coincidir con el enum del back (TipoElementoAcceso). */
export enum TipoElementoAcceso {
	Contrato = 1,
	Centro = 2,
	Oportunidad = 3,
}

export interface AccesoResumen {
	tipoElemento: number;
	elementoId: number;
	numAccesos: number;
	fechaUltimoAcceso: string;
}

/**
 * Registro y consulta de accesos por usuario (recientes / más visitados).
 * Alimenta los bloques "Tus centros" y "Contratos activos" de la home.
 * Tolerante a fallos: si el backend no responde, los métodos resuelven vacío
 * para no romper la pantalla (degradación: se muestra el top por defecto).
 */
@Injectable({ providedIn: "root" })
export class AccesosService {
	constructor(private readonly httpDataService: HttpDataService) {}

	/** Registra (upsert) un acceso del usuario al elemento abierto. No bloquea la UI. */
	registrar(tipo: TipoElementoAcceso, elementoId: number): Observable<void> {
		if (!elementoId) {
			return of(void 0);
		}
		return this.httpDataService
			.post$<void>(ApiEnum.API_ROOT, environment.endpoint.accesos.registrar, {
				tipoElemento: tipo,
				elementoId,
			})
			.pipe(catchError(() => of(void 0)));
	}

	/** Top-N de elementos del tipo para el usuario, por reciente (def.) o por visitas. */
	resumen(
		tipo: TipoElementoAcceso,
		top = 8,
		orden: "Reciente" | "Visitado" = "Reciente",
	): Observable<AccesoResumen[]> {
		const url = `${environment.endpoint.accesos.resumen}?tipo=${tipo}&top=${top}&orden=${orden}`;
		return this.httpDataService
			.get$<AccesoResumen[]>(ApiEnum.API_ROOT, url)
			.pipe(catchError(() => of([] as AccesoResumen[])));
	}
}
